/**
 * Export `formatDate` function.
 */

export function formatDate(date: string) {
  const dateObj = new Date(date);

  return new Intl.DateTimeFormat('pt-PT', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }).format(dateObj);
}

/**
 * Export `getDayType` function.
 */

export function getDayType(date: string) {
  const day = new Date(date).getDay();

  switch (day) {
    case 0:
      return 'sunday';

    case 6:
      return 'saturday';

    default:
      return 'week';
  }
}

/**
 * Export `checkHour` function.
 */

export function checkHour(date: string, hour: string) {
  const partitionDate = date?.split('-');
  const year = parseInt(partitionDate?.[0], 10);
  const month = parseInt(partitionDate?.[1], 10) - 1;
  const day = parseInt(partitionDate?.[2], 10);
  const partitionHour = hour?.split(':');
  const hours = parseInt(partitionHour?.[0], 10);
  const minuts = parseInt(partitionHour?.[1], 10);
  const dataHoraEspecifica = new Date(year, month, day, hours, minuts);
  const now = new Date();

  return dataHoraEspecifica > now;
}

/**
 * Export `incrementOneHour` function.
 */

export function incrementOneHour(time: string) {
  const date = new Date(`1970-01-01T${time}:00Z`);

  date.setUTCHours(date.getUTCHours() + 1);

  return date.toISOString().substring(11, 16);
}
